import { Injectable } from '@angular/core';
import { HttpClientService } from '../http-client/http-client.service';
import { Subscriber } from 'rxjs/Subscriber';
import { Service } from '../service';
import { Observable } from 'rxjs/Observable';
import { ConceptDto } from '../../models/concepts/concept-dto';

@Injectable()
export class ConceptService extends Service {


    public concepts: ConceptDto[];
    public conceptsObject: any;

    constructor(
        private http: HttpClientService
    ) {
        super();
        this.concepts = [];
        this.conceptsObject = {};
    }

    public getAll(): Observable<ConceptDto[]> {
        if (!!this.concepts && this.concepts.length > 0) {
            return Observable.create((observer: Subscriber<ConceptDto[]>) => {
                observer.next(this.concepts);
                observer.complete();
            });
        }
        const url = 'concepts/all';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.concepts = r.Result;
                console.log('this.events', this.concepts);
                this.conceptsObject = this.concepts.reduce((result, s) => {
                    result[String(s.Id)] = result[String(s.Id)] || {};
                    result[String(s.Id)] = s;
                    return result;
                }, {});
            } else {
                console.error('CurriculumService > getAll > response', r);
            }
            return this.concepts;
        }).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/concepts/concept.service.ts